import { dispatch } from "fw-state";
import { ConfirmStore, ShowAction, SetDefaultConfirmStoreAction } from "state/components/confirm";

export class ConfirmService {
    private resolver: any;
    constructor(private store: ConfirmStore) {}

    public async confirm(content): Promise<boolean | string> {
        dispatch(new ShowAction(content));
        return new Promise((resolve) => (this.resolver = resolve));
    }

    public rejectAction(): void {
        dispatch(new SetDefaultConfirmStoreAction());
        this.resolver(false);
    }

    public confirmAction(action: string): void {
        dispatch(new SetDefaultConfirmStoreAction());
        this.resolver(action == "Confirm" || action);
    }
}
